import styled from 'styled-components'

export const StyledBrandsContainer = styled.div({
  display: 'flex'
})
